import React from 'react';
import styles from './FileEmpty.module.scss';
import { ReactComponent as FileFromDocument } from '../../../../resource/FileFromDocument.svg';

const FileEmpty = () => {
  return (
    <div className={styles.root}>
      <div className={styles.iconBlock}>
        <FileFromDocument style={{ color: '#3378F9' }} />
      </div>
      <div className={styles.text}>Вы еще не загрузили ни одного файла</div>
    </div>
  );
};

export default FileEmpty;
